import { styled } from 'styled-components';

import { typography } from '@/styles/helpers';

export const ScTermsAndConditions = styled.div<{ isOpen: boolean }>`
  max-width: 350px;
  width: 100%;
  z-index: 10;
  word-break: break-word;
  margin-top: 16px;
  text-align: center;

  & > .points {
    margin-top: ${({ isOpen }) => (isOpen ? '16px' : 0)};
    p {
      text-transform: none;
      ${typography['body2regular']}
    }
  }

  & > .title {
    display: flex;
    justify-content: center;
    align-items: center;
    ${typography['body2regular']}
    font-weight: 400;
    letter-spacing: 0em;
    text-transform: none;
    text-align: center;
    cursor: pointer;
    color: ${({ theme }) => theme.whiteColor};
    margin-top: 0;

    .arrow {
      width: 16px;
      height: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
      margin-left: 8px;

      & > i {
        transition: transform 0.25s ease-in-out;
        transform: ${({ isOpen }) =>
          isOpen
            ? 'rotate(-90deg) translateY(0) scale(1)'
            : 'rotate(90deg) translateY(0)'};

        color: ${({ theme }) => theme.whiteColor};
      }
    }

    &:hover {
      .arrow {
        & > i {
          transform: ${({ isOpen }) =>
            `rotate(${isOpen ? '-90deg' : '90deg'}) translateY(2px)`};
        }
      }
    }
  }
`;
